import { createSlice } from '@reduxjs/toolkit'

export const TrainingSlice = createSlice({
  name: 'training',
  initialState: {
    clicked: null,
    clickedError: null,

    progress: null,
    progressError: null,

    quiz: null,
    quizError: null,

    trainingStatus: null,
    trainingStatusError: null,

    saveStatus: null,
    resetStatus: null,

    result: null,
    resultError: null
  },
  reducers: {
    updateClicked: (state, action) => {
      state.clicked = action.payload;
      state.clickedError = null;
    },
    notifyClickedError: (state, action) => {
      state.clickedError = action.payload;
    },
    
    updateProgress: (state, action) => {
      state.progress = action.payload;
      state.progressError = null;        
    },
    notifyProgressError: (state, action) => {
      state.progressError = action.payload;
      state.progress = null;        
    },
    refreshProgress: (state) => {
      state.progress = null;
      state.progressError = null;        
    },
  
    updateQuiz: (state, action) => {
      state.quiz = action.payload;
      state.quizError = null;
    },
    notifyQuizError: (state, action) => {
      state.quizError = action.payload;
      state.quiz = null;
    },

    updateTrainingStatus: (state, action) => {
      state.trainingStatus = action.payload;
      state.trainingStatusError = null;
    },
    notifyTrainingStatusError: (state, action) => {
      state.trainingStatusError = action.payload;
      state.trainingStatus = null;
    },

    updateSaveStatus: (state, action) => {
        state.saveStatus = action.payload
    },

    updateResetStatus: (state, action) => {
      state.resetStatus = action.payload
    },
    refreshResetStatus: (state) => {
      state.resetStatus = null
    },

    updateResult: (state, action) => {
        state.result = action.payload;
        state.resultError = null;        
    },
    notifyResultError: (state, action) => {
        state.resultError = action.payload;
        state.result = null;        
    },
    refreshResult: (state) => {
      state.result = null;
      state.resultError = null;        
    },
  }
})

// Action creators are generated for each case reducer function
export const { updateProgress, notifyProgressError, refreshProgress, updateSaveStatus, updateResult, notifyResultError, refreshResult, updateResetStatus, refreshResetStatus, updateClicked, notifyClickedError, updateQuiz, notifyQuizError, updateTrainingStatus, notifyTrainingStatusError } = TrainingSlice.actions

export default TrainingSlice.reducer